const InvalidDomainIdErrorMessage = 'Invalid id';

export class InvalidDomainIdError extends Error {
  static Name = 'InvalidDomainIdError';

  constructor() {
    super(InvalidDomainIdErrorMessage);
    this.name = InvalidDomainIdError.Name;
  }
}

const toRecord = (value: unknown): Record<string, unknown> | undefined => {
  if (typeof value !== 'object' || value === null) return undefined;
  return value as Record<string, unknown>;
};

export const isInvalidDomainIdError = (error: unknown): error is InvalidDomainIdError => {
  if (error instanceof InvalidDomainIdError) return true;
  const record = toRecord(error);
  return record?.name === InvalidDomainIdError.Name && record.message === InvalidDomainIdErrorMessage;
};
